/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * PaypalExpressEditState Input Action
 */
export class PaypalExpressEditStateInput implements Msdyn365.IActionInput {
    // PaypalExpressEditStat: Construct the input needed to run the action
    constructor() {}

    // PaypalExpressEditStat: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `PaypalExpressEditStat`;
    public getCacheObjectType = () => 'PaypalExpressEditStat';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// PaypalExpressEditStat: Create a data model here or import one to capture the response of the action
export interface IPaypalExpressEditStateData {
    isDisabled : boolean
}

/**
 * PaypalExpressEditStat: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new PaypalExpressEditStateInput();
};

/**
 * PaypalExpressEditStat: Use this function to call your action and process the results as needed
 */
async function action(input: PaypalExpressEditStateInput, ctx: Msdyn365.IActionContext): Promise<IPaypalExpressEditStateData> {
    // const apiSettings = Msdyn365.msdyn365Commerce.apiSettings;

    // PaypalExpressEditStat: Uncomment the below line to get the value from a service
    // const response = await Msdyn365.sendRequest<IPaypalExpressEditStateData[]>('/get/example/id/1', 'get');
    return { isDisabled : true };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IPaypalExpressEditStateData>>action,
    // PaypalExpressEditStat: Give your data action a unique id
    id: 'PaypalExpressEditState',
    input: createInput
    // PaypalExpressEditStat: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
